'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.provisionPartner = provisionPartner;
exports.fetchPartnerPrivacyLink = fetchPartnerPrivacyLink;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _I18n = require('I18n');

var _apiClient = require('../utils/http/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _QueryParamsContainer = require('../globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//this will be replaced with an actual call to settings
var BETA_PARTNER_TO_PRIVACY_LINK = {
  // this is the demo portal on QA
  '99782630': {
    privacy: 'https://qademoportal.com/privacy',
    company: 'QA DEMO Portal'
  },
  // this is the test portal in PROD
  '4815820': {
    privacy: 'https://demoportalprod.com/privacy',
    company: 'PROD DEMO Portal'
  },

  // beta partners
  '527310': {
    privacy: 'https://makingexperience.com/politica-de-privacidad/',
    company: 'MakingExperience'
  },
  '249181': {
    privacy: 'https://www.manobyte.com/privacy-and-security',
    company: 'ManoByte'
  },
  '308131': {
    privacy: 'https://www.avidlyagency.com/privacy-statement',
    company: 'Avidly'
  },
  '465916': {
    privacy: 'https://www.ids.agency/es/privacy',
    company: 'IDS SpA'
  },
  '4016590': {
    privacy: 'https://app.transfunnel.com/privacy-policy',
    company: 'Transfunnel'
  },
  '299528': {
    privacy: 'https://www.storylead.ch/datenschutz',
    company: 'storylead'
  },
  '145335': {
    privacy: 'https://www.impactbnd.com/privacy-policy',
    // Marking '&' as a safe escape character
    company: (0, _I18n.SafeString)('Impact Branding & Design LLC')
  },
  '142915': {
    privacy: 'https://www.smartbugmedia.com/privacy-policy',
    company: 'SmartBug Media'
  },
  '2354649': {
    privacy: 'https://www.iubenda.com/privacy-policy/683514/cookie-policy',
    // Marking '&' as a safe escape character
    company: (0, _I18n.SafeString)('Del Monte & Partner')
  },
  '2689406': {
    privacy: 'https://www.digitalbuildingblocks.it/privacy-policy/',
    company: 'Digital Building Blocks'
  },
  '2072760': {
    privacy: 'https://www.ictsviluppo.it/privacy/',
    company: 'ICT Sviluppo Srl'
  },
  '529315': {
    privacy: 'https://www.storyblock.media/privacy-policy',
    company: 'Story Block Media'
  },
  '74005': {
    privacy: 'https://www.lyntonweb.com/privacy-policy',
    company: 'LyntonWeb'
  },
  '189441': {
    privacy: 'https://www.clearpivot.com/privacy-policy',
    company: 'ClearPivot'
  },
  '1629543': {
    privacy: 'https://www.yokellocal.com/privacy-policy/',
    company: 'Yokel Local'
  },
  '136649': {
    privacy: 'https://skodaminotti.com/privacy-policy',
    company: 'Skoda Minotti'
  },
  '2227080': {
    privacy: 'https://www.cloudnova.it/privacy-policy',
    company: 'Cloudnova srl'
  },
  '537724': {
    privacy: 'https://modassicmarketing.com/privacy-policy',
    company: 'MODassic Marketing'
  },
  '616662': {
    privacy: 'https://www.hooklead.com/privacy-policy/',
    company: 'HookLead'
  },
  '1611177': {
    privacy: 'https://www.sixandflow.com/privacy-policy',
    // Marking '&' as a safe character
    company: (0, _I18n.SafeString)('Six & Flow')
  },
  '1567250': {
    privacy: 'https://www.clients-first.co.uk/privacy-policy/',
    company: 'ClientsFirst'
  },
  '40444': {
    privacy: 'https://www.precisionmarketinggroup.com/privacy-policy',
    company: 'Precision Marketing Group'
  },
  '433607': {
    privacy: 'https://www.penguinstrategies.com/privacy-policy',
    company: 'Penguin Strategies'
  },
  '161406': {
    privacy: 'https://www.mojomedialabs.com/privacy-policy',
    company: 'Mojo Media Labs'
  }
};

function provisionPartner(partnerType, domain) {
  return _apiClient2.default.post('partnerdb/v1/provisioning/touchless', {
    data: {
      partnerType: partnerType,
      countryCode: _QueryParamsContainer2.default.get('country') || '',
      domain: domain
    }
  });
}

function fetchPartnerPrivacyLink(partnerId) {
  return _q2.default.Promise.resolve({
    partnerPrivacyLink: BETA_PARTNER_TO_PRIVACY_LINK[partnerId].privacy,
    partnerCompany: BETA_PARTNER_TO_PRIVACY_LINK[partnerId].company
  });
}